import React from 'react';
import PropTypes from 'prop-types';
import { MINIMUM_DESCRIPTION_LENGTH } from '../../constants';
import Button from '../Button';
import { Form, Input } from '../Form';
import Link from '../Link';
import SecondaryAction from '../SecondaryAction';
import Style from '../Style';
import { H3, L2, L3, P1, P2 } from '../Typography';

class LicenseInput extends React.PureComponent {
  static propTypes = {
    onCancel: PropTypes.func,
    onSubmit: PropTypes.func,
    licensingError: PropTypes.string,
  };
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {
      fetching: false,
      formEnabled: true,
      description: '',
      error: '',
    };
  }

  onChange = value => {
    this.setState({ error: '', description: value });
  };

  onSubmit = () => {
    if (!this.state.formEnabled) {
      return;
    }

    if (this.state.description.length < MINIMUM_DESCRIPTION_LENGTH) {
      this.setState({ error: 'Description is too short.' });
      return;
    }

    this.setState({ formEnabled: false, fetching: true });
    this.props
      .onSubmit(this.state.description)
      .then(() => this.setState({ fetching: false }))
      .catch(() =>
        this.setState({
          formEnabled: true,
          fetching: false,
          error: 'Uh oh. Something went wrong',
        }),
      );
  };

  render() {
    const { onCancel, onSubmit, licensingError, ...otherProps } = this.props;

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '10rem 6rem 6rem',
        }}
      >
        <H3 style={{ marginBottom: '4rem' }}>License this clip</H3>
        <Form onSubmit={this.onSubmit}>
          <Input
            name="description"
            type="text"
            value={this.state.description}
            onChange={this.onChange}
            placeholder="Describe your video project here..."
          >
            HOW WILL YOU USE THIS CLIP?
          </Input>
        </Form>

        <span
          style={{
            width: '100%',
            marginTop: '1rem',
            color: Style.Colors.error,
          }}
        >
          {licensingError || this.state.error || <span>&nbsp;</span>}
        </span>

        <L3
          style={{
            display: 'block',
            width: '100%',
            marginTop: '4rem',
            color: Style.Colors.shadow2,
          }}
        >
          TERMS &amp; CONDITIONS
        </L3>
        <P1
          style={{
            display: 'block',
            marginBottom: '6rem',
            color: Style.Colors.shadow3,
          }}
        >
          By licensing this clip, you agree to our{' '}
          <Link underline={true} to="/legal" target="_blank">
            terms of use
          </Link>, and agree to only use it for your specified project.
        </P1>

        <Button
          arrow={true}
          onClick={this.onSubmit}
          working={this.state.fetching}
        >
          Agree &amp; Continue
        </Button>
        <SecondaryAction onClick={onCancel}>Cancel</SecondaryAction>
      </div>
    );
  }
}

export default LicenseInput;



// WEBPACK FOOTER //
// ./src/components/LicenseInput/LicenseInput.js